export const EMAIL_REGEX = new RegExp('^[\\w-\\.+]+@([\\w-]+\\.)+[\\w-]{2,4}$')

export const OTP_REGEX = new RegExp('^\\d{6}$')
